import { useEffect, useState } from 'react';

/* =============================================================================
   Detection de la taille d'ecran, en JavaScript et non en CSS.
   ─────────────────────────────────────────────────────────────────────────
   Le tableau de bord et le plan de travail sont ecrits en styles en ligne :
   une media query CSS ne peut pas les atteindre. Il ne s'agit d'ailleurs pas
   seulement de retailler — sur petit ecran, certaines vues changent de nature
   (le plan de travail passe d'un plan libre a une pile verticale). Cela se
   decide en JavaScript.

   Deux seuils :
     estMobile  (<= 640px) : telephone. Textes et graphes retailles.
     estCompact (<= 900px) : telephone et petite tablette. En plus, on renonce
                             au positionnement libre du plan de travail : sur
                             cette largeur, deplacer des elements a la main n'a
                             aucun sens, on empile.
   ============================================================================= */

const SEUIL_MOBILE = 640;
const SEUIL_COMPACT = 900;

const mesurer = () => {
  const l = typeof window === 'undefined' ? 1200 : window.innerWidth;
  return { largeur: l, estMobile: l <= SEUIL_MOBILE, estCompact: l <= SEUIL_COMPACT };
};

export function useEcran() {
  const [ecran, setEcran] = useState(mesurer);

  useEffect(() => {
    // On ne re-rend que si l'on change de palier : redimensionner la fenetre
    // pixel par pixel ne doit pas redessiner tous les graphes.
    const surRedimensionnement = () => {
      setEcran((avant) => {
        const apres = mesurer();
        return apres.estMobile === avant.estMobile && apres.estCompact === avant.estCompact
          ? avant
          : apres;
      });
    };
    window.addEventListener('resize', surRedimensionnement);
    window.addEventListener('orientationchange', surRedimensionnement);
    return () => {
      window.removeEventListener('resize', surRedimensionnement);
      window.removeEventListener('orientationchange', surRedimensionnement);
    };
  }, []);

  return ecran;
}
